import { ServiceHelper } from "./services.helper";

export type FieldToValidate = { id?: string; name: string; value: string | number | boolean; minLength?: number; errorMessage?: string };

export class FormHelper {

    static checkForEmptyField(fields: FieldToValidate[], displayValidationErrors = true) {
        let missing = '';
        const missingFields: FieldToValidate[] = [];
        for (const field of fields) {
            if (typeof (field.value) === 'string' && field.minLength && field.value.length < field.minLength) {
                const message = `• ${field.name} requires a minimum of ${field.minLength} characters<br/>`;
                field.errorMessage = field.errorMessage ?? message;
                missing += message;
            } else if (!field.value) {
                missingFields.push(field);
                missing += `• ${field.name} is required<br/>`;
            }
        }
        if (missing.length > 0 && displayValidationErrors === true) {
            ServiceHelper.displayAlert('Missing Fields', missing);
            // this.focusInvalidElements(missingFields);
            return false;
        }
        return missing.length === 0;
    }

    static focusInvalidElements(elements: FieldToValidate[]) {
        elements.forEach(invalidEl => {
            const invalidControl: HTMLElement = document.querySelector(`[id="${invalidEl.id}"]`);
            if (invalidControl && !invalidControl.classList.contains('invalid-el')) {
                invalidControl.classList.add('invalid-el');
                const errorElement = document.createElement('p');
                errorElement.innerHTML = `${invalidEl.errorMessage ?? 'This field is required'}*`;
                errorElement.className = 'danger';
                invalidControl.before(errorElement);
                invalidControl.addEventListener('ionChange', (event) => {
                    // probs have to put validation check here to verifiy if we can perform the operations below
                    errorElement.remove();
                    invalidControl.classList.remove('invalid-el');
                    invalidControl.removeEventListener('ionChange', null);
                });
            }
        });
    }
}
